import { z } from "zod";

import { ShippingRateGroupDtoSchema } from "../../../dtos/shipping-rate-groups";

import { PluginAudienceSchema_2024_05_05 } from "./audiences/2024-05-05";
import { PluginBuiltBySchema_2024_05_05 } from "./built-by/2024-05-05";
import { PluginExclusionGroupSchema_2024_05_05 } from "./exclusion-groups/2024-05-05";
import { PluginExperienceProductsSchema_2024_05_05 } from "./experience-products/2024-05-05";
import { PluginExperienceSchema_2024_05_05 } from "./experiences/2024-05-05";
import { PluginIntegrationSchema_2024_05_05 } from "./integrations/2024-05-05";
import { PluginOfferSchema_2024_05_05 } from "./offers/2024-05-05";
import { PluginOfferProductSchema_2024_05_05 } from "./offers/offerProducts/2024-05-05";
import { PluginOnsiteEditSchema_2024_05_05 } from "./onsite-edits/2024-05-05";
import { PluginOnsiteInjectionSchema_2024_05_05 } from "./onsite-injections/2024-05-05";
import { PluginOptionsSchema_2024_05_05 } from "./options/2024-05-05";
import { PluginRedirectSchema_2024_05_05 } from "./redirects/2024-05-05";
import { PluginUserInterfaceSchema_2024_05_05 } from "./userInterfaces/2024-05-05";
import { PluginVariationSchema_2024_05_05 } from "./variations/2024-05-05";
import { PluginWidgetSchema_2024_05_05 } from "./widgets/2024-05-05";
import { PluginExperiencePageTargetingSchema } from "./experiencePageTargeting";
import { PluginShippingRateGroupSchema } from "./shipping";

export * from "./exclusion-groups";
export * from "./experiments";
export * from "./options";
export * from "./redirects";
export * from "./widgets";

export const PluginConfigSchema_2024_05_05 = z.object({
  storeName: z.string(),
  orgId: z.string().uuid(),
  buildId: z.number(),
  version: z.literal("2024-05-05"),
  audiences: PluginAudienceSchema_2024_05_05.array().default([]),
  experiencePageTargeting: PluginExperiencePageTargetingSchema.array().default(
    []
  ),
  experiences: PluginExperienceSchema_2024_05_05.array().default([]),
  offers: PluginOfferSchema_2024_05_05.array().default([]),
  offerProducts: PluginOfferProductSchema_2024_05_05.array().default([]),
  variations: PluginVariationSchema_2024_05_05.array().default([]),
  experienceProducts: PluginExperienceProductsSchema_2024_05_05.array().default(
    []
  ),
  shippingRateGroups: PluginShippingRateGroupSchema.array().default([]),
  onsiteEdits: PluginOnsiteEditSchema_2024_05_05.array().default([]),
  onsiteInjections: PluginOnsiteInjectionSchema_2024_05_05.array().default([]),
  userInterfaces: PluginUserInterfaceSchema_2024_05_05.array().default([]),
  redirects: PluginRedirectSchema_2024_05_05.array().default([]),
  exclusionGroups: PluginExclusionGroupSchema_2024_05_05.array().default([]),
  widgets: PluginWidgetSchema_2024_05_05.array().default([]),
  integrations: PluginIntegrationSchema_2024_05_05.array().default([]),
  options: PluginOptionsSchema_2024_05_05,
  builtBy: PluginBuiltBySchema_2024_05_05,
});

export type PluginConfigType_2024_05_05 = z.infer<
  typeof PluginConfigSchema_2024_05_05
>;
